query getSectors {
    getSectors
}
